// extracted by mini-css-extract-plugin
export default {"card":"Card_card__pqOY8","image":"Card_image__NW-HJ","down":"Card_down__qZlL-","left":"Card_left__19Ctf","right":"Card_right__AbnIA"};